import { UserContext } from '../context/user-context'
import { useContext } from 'react'
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({children}) => {
    const { user } = useContext(UserContext)
    return user ? children : <Navigate to="/login" />
}

export default ProtectedRoute